import { render } from "./Question.vue?vue&type=template&id=381a60a6"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"

import "./Question.vue?vue&type=style&index=0&id=381a60a6&lang=css"
script.render = render

export default script